import Big from 'big.js';
import React from 'react';

import { useCompanySnapShotSummaryQuery } from 'generated/graphql';
import { DateTime } from 'luxon';



export interface IData {
  id: string;
  name: string;
  stockPriceDate: DateTime | null;
  currentStockPrice: Big | null;
  changePercent: Big | null;
}

export function useQuery(id?: string) {
  const tuple = useCompanySnapShotSummaryQuery({
    variables: {
      id: id ?? ''
    },
    skip: !id
  });

  return React.useMemo(
    () => {
      const listedCompany = tuple.data?.listedCompany;
      const stockPrice = listedCompany?.latestStockPrice;
      const data: IData = {
        id: listedCompany?.id ?? '',
        name: listedCompany?.companyName ?? '',
        stockPriceDate: stockPrice?.date ?? null,
        currentStockPrice: stockPrice?.value ?? null,
        changePercent: listedCompany?.percentChangeSinceYesterday ?? null
      };

      return {
        ...tuple,
        data
      };
    },
    [tuple]
  );
}
